import { render, staticRenderFns } from "./sanity-media.global.vue?vue&type=template&id=58979ea3&"
import script from "./sanity-media.global.vue?vue&type=script&lang=js&"
export * from "./sanity-media.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports